export default {
  API_URL: process.env.VUE_APP_API_URL || '',
  RECAPTCHA_SITE_KEY: process.env.VUE_APP_RECAPTCHA_SITE_KEY || '',
  ANALYTICS_ID: process.env.VUE_APP_ANALYTICS_ID || '',
  ENV: process.env.VUE_APP_ENV || 'dev'
}
